import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, message, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";


import {
  Image,
  Select,
  TimePicker,
  Upload,
} from "antd";
import bannerRequest from "./webContactRequest";
import WebContactRequest from "./webContactRequest";
const initialFilter = { page: 1, limit: 10 };

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


function WebContactUpdate() {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const navigate = useNavigate()
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [pathType, setPathType] = useState(''); // Store selected pathType
  const [pathIdOptions, setPathIdOptions] = useState([]); // Store fetched pathId options
  const [options, setOptions] = useState([]); // Options for select
  const { id } = useParams();
  const { Option } = Select;
  const [bannerDetails, setBannerDetails] = useState({});
  const [submited, setSubmit] = useState(false);



  useEffect(() => {
    console.log("id:", id);
    const getBannerDetails = async () => {
      setLoading(true);

      try {

        const res = await WebContactRequest.getContactDetail(id);
        console.log("API response:", res);

        const bannerData = res?.data?.data;
        console.log(bannerData, 'bannerData')

        if (bannerData) {
          const mappedData = {
            ...bannerData,

            status: bannerData?.status === 1 ? "1" : "0",


          }
          setBannerDetails(mappedData)
          console.log("mappedData", mappedData);
      
          if (mappedData.imageUrl) {
            setFileList([{ url: mappedData.imageUrl, name: "Uploaded Image" }]);
          }
          form.setFieldsValue(mappedData);
        }

      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    if (id) getBannerDetails();
  }, [id, form]);

const update=()=>{
  setSubmit(true);
}

  const onFinish = (values) => {
    console.log("Form values:", values);
    console.log("first",submited)
    if(submited){
      setLoading(true);
      const formData = { ...values, id : id };
  
      WebContactRequest.postUpdateContact(formData)
        .then((res) => {
          if (res.status === 200) {
            notification["success"]({
              message: "Contact details updated successfully",
            });
            navigate(-1, { state: { refresh: true } });
          } else {
            notification["error"]({
              message: "Something went wrong",
            });
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          notification["error"]({
            message: "Failed",
          });
        });
    }
   
  };


 

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };


  
  return (
      <div>
         <section>
           <div className="Create-Category">
             <Form.Item className=" submit-btn">
               <Space>
                 <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                   <ArrowLeftOutlined />
                 </Button>
               </Space>
             </Form.Item>
             <h3>Create Contact Details</h3>
   
   
             <Form
               layout="vertical"
               className="subscription-form"
               form={form}
               onFinish={onFinish}
             >
               <div className="subscription">
                 <Form.Item
                   label="Page Key"
                   name="pageKey"
                   className="subscription-plan"
                   rules={[
   
                     {
                       pattern: /^[a-z0-9-]+$/,
                       message: "pageKey can contain only lowercase letters, numbers, and hyphens",
                     },
                   ]}
                 >
                   <Input size="large" placeholder="where you want to place this contact details" />
                 </Form.Item>
   
                 <Form.Item
                   label="Status"
                   name="status"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please select status" },
                   ]}
                 >
                   <Select
                     placeholder="Select status"
                     // style={{
                     //   marginTop: "0.5rem",
   
                     //   width: "99%",
                     // }}
                     onChange={handleChange}
                     options={[
                       {
                         value: "0",
                         label: "Inactive",
                       },
                       {
                         value: "1",
                         label: "Active",
                       },
   
                     ]}
                   />
                 </Form.Item>
               </div>
   
               <div className="subscription">
                 <Form.Item
                   label="Location"
                   name="location"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please enter location" },
                     {
                       pattern: /^[A-Za-z\s,.'-]+$/,
                       message: "Location can only contain letters, spaces, commas, periods, hyphens and apostrophes!",
                     },
                     {
                       min: 2,
                       message: "Location must be at least 2 characters long",
                     },
                   ]}
                 >
                   <Input size="large" placeholder="Enter location" />
                 </Form.Item>
   
                 <Form.Item
                   label="Email "
                   name="email"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please enter email" },
                     {
                       type: "email",
                       message: "Please enter a valid email address!",
                     },
                   ]}
                 >
                   <Input size="large" placeholder="example@email.com" />
                 </Form.Item>
               </div>
   
   
               <div className="subscription">
   
                 <Form.Item
                   label="Mobile Number"
                   name="mobile"
                   className="subscription-plan"
                   rules={[
                     {
                       required: true,
                       message: "Please enter mobile number",
                     },
                     {
                       pattern: /^[6-9]\d{9}$/,
                       message: "Please enter a valid 10-digit mobile number",
                     },
                   ]}
                 >
                   <Input
                     size="large"
                     placeholder="Enter mobile"
                     maxLength={10}
                   />
                 </Form.Item>
               </div>
   
   
   
   
   
   
               <div className="bottom-button">
                 <div style={{ padding: "10px" }}>
                   <Button type="primary" htmlType="submit" loading={loading} onClick={update}>
                     Save & Proceed
                     <span>
                       <AiOutlineRight />
                     </span>
                   </Button>
                 </div>
               </div>
   
             </Form>
           </div>
         </section>
       </div>
  )
}
export default WebContactUpdate